import { ChangeEvent } from 'react';
import { Flex } from '@chakra-ui/layout';
import { Select } from '@chakra-ui/select';

import type {
  BucketData,
  FileAttachment,
} from '@/modules/fileUploader/fileUploaderEntity';
import { useUploaderBucket } from '@/modules/fileUploader/fileUploaderHook';
import { InputFileButton } from '@/uikit/component/InputFileButton';

type FileUploaderFormProps = {
  presetID: string;
  isLoading?: boolean;
  onChangePresetID: (presetID: string) => void;
  onUploadFiles: (files: Array<FileAttachment>) => void;
  selectedBucket?: BucketData;
};

function FileUploaderForm({
  presetID,
  isLoading,
  onChangePresetID,
  onUploadFiles,
  selectedBucket,
}: FileUploaderFormProps) {
  const { data: uploaderBucketData = [] } = useUploaderBucket();

  const onChangeFileInput = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files) {
      let i = 0;
      const newFiles: Array<FileAttachment> = [];

      while (i < files.length) {
        const item = files.item(i);

        if (item) {
          newFiles.push({ name: item.name, file: item });
        }

        i++;
      }

      onUploadFiles(newFiles);
    }
  };

  return (
    <Flex
      background="white"
      alignItems="center"
      borderRadius="full"
      p="0.3rem"
      boxShadow="0px 6px 20px 4px rgba(113, 130, 164, 0.08)"
    >
      <Select
        required
        placeholder="Choose storage bucket"
        value={presetID}
        onChange={(event) => onChangePresetID(event.target.value)}
        variant="filled"
        background="white"
        _hover={{ background: 'gray.50' }}
        borderRadius="full"
        fontSize="sm"
        height="3rem"
      >
        {uploaderBucketData.map((item, i) => (
          <option key={`${i}-${item.presetID}`} value={item.presetID}>
            {`${item.label} [${item.presetID}]`}
          </option>
        ))}
      </Select>
      <InputFileButton
        onChange={onChangeFileInput}
        label="Upload File"
        // multiple={selectedBucket?.multiple_upload} // TODO: need to handle multiple upload file
        mimeTypes={selectedBucket?.mimeTypes}
        maxSize={selectedBucket?.maxSize}
        isLoading={isLoading}
        isDisabled={isLoading || !presetID}
        borderRadius="full"
        height="3rem"
        px="2rem"
        ml="0.5rem"
      />
    </Flex>
  );
}

export { FileUploaderForm };
